// src/api/api.js
import axiosInstance from '../utils/axiosInstance';

export const getUserData = async () => {
  console.log("[api/api.js] Getting UserData from server....");

  try {
    const response = await axiosInstance.get(`/knovia/userdata`);
    return response.data;
  } catch (error) {
    console.error("[api/api.js] Error getting user data:", error.message);
    // Additional handling, e.g., notifying user, retrying request, etc.
    throw new Error("Failed to get user data. Please try again later.");
  }
};

export const updateUser = async (userData) => {
  console.log("[api/api.js] Updating UserData from server...");
  
  try {
    const response = await axiosInstance.put(`/knovia/updateuser`, userData);
    return response.data;
  } catch (error) {
    console.error("[api/api.js] Error updating user data:", error.message);
    // Additional handling, e.g., notifying user, retrying request, etc.
    throw new Error("Failed to update user data. Please try again later.");
  }
};

export const userLogin = async (res) => {
  console.log("[api/api.js] User Login Processing....");
  try {
    const { email, password } = res;
    const response = await axiosInstance.post('/knovia/login', { email, password });

    // Setting the JWT token in localStorage
    const { accessToken, refreshToken } = response.data;
    const authUser = { accessToken, refreshToken, email };
    localStorage.setItem("authUser", JSON.stringify(authUser));
    // Reset isRedirectedToLogin
    sessionStorage.removeItem("isRedirectedToLogin");

    return response.data;
  } catch (error) {
    console.error("[api/api.js] Error in userLogin:", error.message);

    // Optionally display the specific error message from backend
    if (error.message.includes('帳號尚未驗證')) {
      // Handle specific case for unverified accounts
      //alert("帳號尚未驗證，請先至註冊信箱收取驗證信，並點擊連結驗證您的帳號");
    } else {
      //alert("Login failed. " + error.message);
    }

    throw new Error(error.message); // Propagate the error
  }
};

export const googleUserLogin = async (res) => {
  console.log("[api/api.js] Google user Login Processing...");
  try {
    const googleToken = res.credential;
    const response = await axiosInstance.post(`/knovia/google-login`, { googleToken });

    const { accessToken, refreshToken } = response.data;
    const authUser = { accessToken, refreshToken };
    localStorage.setItem("authUser", JSON.stringify(authUser));
    sessionStorage.removeItem("isRedirectedToLogin");

    return response.data;
  } catch (error) {
    console.error("[api/api.js] Error in googleUserLogin:", error.message);
    // Additional handling, e.g., notifying user, clearing local storage, etc.
    throw new Error(error.message || "Google login failed. Please try again later.");
  }
};

export const verifyAccountApi = async (token) => {
  console.log("[api/api.js] Verifying account from server...");
  
  try {
    const response = await axiosInstance.post('/knovia/verify-account', { token });
    return response.data;
  } catch (error) {
    console.error("[api/api.js] Error verifying account:", error.message);
    // Additional handling, e.g., notifying user, retrying request, etc.
    throw new Error("Account verification failed. Please try again later.");
  }
};

